import styled from 'styled-components'


export const ContainerEyer = styled.div`
  display: flex;
  gap: 1.5rem;

  align-items: center;
  justify-content: center;

  > div:first-child {
    flex: 1;
  }
`;
